/* Stylesheet */

.toolbar_container {
  //   padding: 0px 21px 0px 21px;
  display: flex;
  height: 52px;
  align-items: center;
  background: var(--ion-gradient-dark);
  overflow: hidden;

  .icon_container {
    margin: 0px 0px 0px 12px;
    display: flex;
    height: 40px;
    width: 40px;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 52px;

    .icon {
      height: 24px;
      width: 24px;
      color: #233854;
    }
  }

  .label {
    margin: 0px 0px 0px 16px;
    font-size: 1rem;
    font-weight: 500;
    color: var(--ion-color-text-secondary);
  }
}
